import { forwardRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserStorage } from '@atc/browser-storage';
import { Overlay, PopoverMenu, Glyphicon, SubHeading, Text, Button } from 'reaxl';
import { jsx, jsxs } from 'react/jsx-runtime';
const userInteractionsCache = /* #__PURE__*/new BrowserStorage('USER_INTERACTIONS', {
  persist: true
});
const WalletPopover = /*#__PURE__*/forwardRef((_ref, outerRef) => {
  let {
    withPopover,
    paymentsDuck,
    className,
    targetRef // Added for backwards compatibility support.
  } = _ref;
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const userInteractions = userInteractionsCache.getItem();
  const creditType = useSelector(paymentsDuck.selectors.getCreditType);
  const displayMyWalletModal = useSelector(paymentsDuck.selectors.getDisplayMyWalletModal);
  const hasUpdatedWallet = useSelector(state => paymentsDuck.selectors.getMyWalletInteraction(state, 'hasUpdatedWallet'));
  const disablePaymentPopover = useSelector(state => paymentsDuck.selectors.getMyWalletInteraction(state, 'disablePaymentPopover'));
  const displayPaymentsOnListings = useSelector(state => paymentsDuck.selectors.getMyWalletInteraction(state, 'paymentEmphasis'));
  const updatePaymentEmphasis = _ref2 => {
    let {
      toggleState
    } = _ref2;
    dispatch(paymentsDuck.creators.updateMyWalletInteractions({
      paymentEmphasis: toggleState,
      disablePaymentPopover: true
    }));
    userInteractionsCache.setItem({
      ...userInteractions,
      disablePaymentsPopover: true
    });
  };
  const toggleMyWalletModal = () => {
    dispatch(paymentsDuck.creators.updateMyWallet({
      displayModal: !displayMyWalletModal
    }));
  };
  const handleShowPaymentsClick = () => {
    updatePaymentEmphasis({
      toggleState: true
    });
    toggleMyWalletModal();
  };
  const handleDisablePaymentPopover = () => {
    dispatch(paymentsDuck.creators.updateMyWalletInteractions({
      disablePaymentPopover: true
    }));
    userInteractionsCache.setItem({
      ...userInteractions,
      disablePaymentsPopover: true
    });
  };

  //     /* DISABLE popover when paymentsInfo has loaded into state (a non-null creditType value should tell us) AND:
  // *    1. User has previously updated wallet (hasUpdatedWallet)
  // *    2. paymentEmphasis has been enabled (displayPaymentsOnListings = true)
  // *    3. User has clicked 'Not now' to skip (disablePaymentPopover = true)
  // *    4. Feature flag disables it (hidePaymentsPopover = true)
  // */
  const popoverIsDisabled = !withPopover || !!userInteractions?.disablePaymentsPopover || disablePaymentPopover || displayMyWalletModal;
  const walletStorageHasLoaded = !!creditType;
  const hasInteractedWithWallet = !!hasUpdatedWallet && displayPaymentsOnListings;
  const shouldRenderPaymentsPopover = !popoverIsDisabled && walletStorageHasLoaded && !hasInteractedWithWallet;
  useEffect(() => {
    if (shouldRenderPaymentsPopover && (targetRef?.current || outerRef?.current)) {
      setShow(true);
    } else if (show) {
      setShow(false);
    }
  }, [shouldRenderPaymentsPopover, outerRef, targetRef, setShow, show]);
  return /*#__PURE__*/jsx(Overlay, {
    show: show,
    placement: "bottom",
    target: targetRef?.current || outerRef?.current,
    children: /*#__PURE__*/jsxs(PopoverMenu, {
      className: className,
      id: "payments-popover-menu",
      placement: "bottom",
      children: [/*#__PURE__*/jsxs("div", {
        className: "margin-bottom-2 display-flex align-items-center",
        children: [/*#__PURE__*/jsx(Glyphicon, {
          glyph: "wallet",
          className: "text-size-500 text-accent"
        }), /*#__PURE__*/jsx(SubHeading, {
          className: "margin-top-1 margin-left-1",
          size: 400,
          children: "My Wallet"
        })]
      }), /*#__PURE__*/jsx(Text, {
        className: "display-block margin-bottom-4",
        children: "Customize your terms and see estimated payments as you search."
      }), /*#__PURE__*/jsxs("div", {
        className: "display-flex justify-content-end",
        children: [/*#__PURE__*/jsx(Button, {
          bsStyle: "link",
          onClick: handleDisablePaymentPopover,
          children: "Not now"
        }), /*#__PURE__*/jsx(Button, {
          onClick: handleShowPaymentsClick,
          bsStyle: "primary",
          children: "Show Payments"
        })]
      })]
    })
  });
});
export { WalletPopover as default };
